import React from "react";
import { Row, Col } from "react-bootstrap";

import Api from "../utils/Api";

const console = window.console;

export default class Importer extends React.Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			file: null
		};

		this.handleFileChange = this.handleFileChange.bind(this);
		this.handleFileProcess = this.handleFileProcess.bind(this);
		this.handleFileUpload = this.handleFileUpload.bind(this);
	}

	async handleFileProcess()
	{
		if (!this.state.fileId) {
			console.error("No fileId.");
			return;
		}

		try
		{
			const columns = await Api.getColumns(this.state.fileId);
			console.log(columns);
			this.setState({ file: null, fileId: null });
		}
		catch (message)
		{
			console.error("Process failed", message);
		}
	}

	async handleFileUpload()
	{
		if (!this.state.file) {
			console.error("No file.");
			return;
		}

		try
		{
			const fileId = await Api.uploadFile(this.state.file);
			this.setState({ file: null, fileId });
		}
		catch (message)
		{
			console.error("Upload failed", message);
		}
	}

	handleFileChange(event)
	{
		let file = null;

		if (event.target.files && event.target.files.length > 0) {
			file = event.target.files[0];
		} else {
			console.error("event.target.files", event.target.files);
		}

		this.setState({
			file
		});
	}

	render()
	{
		const fileName = this.state.file && this.state.file.name;

		return (
			<Row>
				<Col xs={6} md={6}>
					<label className="btn btn-primary btn-file">
						<input type="file" hidden onChange={this.handleFileChange} />
						Select file
					</label>
					<span className="label label-info">{fileName}</span>
				</Col>
				<Col xs={6} md={6}>
					{this.state.file &&
						<button className="btn btn-primary" onClick={this.handleFileUpload}>Upload</button>
					}
					{this.state.fileId &&
						<button className="btn btn-primary" onClick={this.handleFileProcess}>Get Columns</button>
					}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./Components/components/Importer.jsx